(() => {
  window.adlWallPaperLeft = parseInt(window.park.exports.containerWidth +
    window.park.exports.globalSpacing, 10);

  window.oms_sbwp_top = parseInt(window.park.exports.globalSpacing, 10);

  window.omsv_centered = true;
})();
